export default __webpack_public_path__ + "static/media/bg5.76c75ec7.png";